/**
 * Gallery Stores Index - Centralized store initialization
 * Order matters - some stores depend on others being available
 */

import { createGalleryCoreStore } from './core-store.js';
import { createGalleryProductsStore } from './products-store.js';
import { createGalleryUIStore } from './ui-store.js';
import { createGalleryMemoryStore } from './memory-store.js';
import { createGalleryVariantsStore } from './variants-store.js';
import { createGalleryLayoutStore } from './layout-store.js';
import { createGallerySelectionStore } from './selection-store.js';
import { createGalleryGlobalStore } from './global-store.js';
import { createGalleryPreviewStore } from './preview-store.js';
import { createRandomizeQueueStore } from './randomize-queue-store.js';

export function initializeGalleryStores() {
  document.addEventListener('alpine:init', () => {

    // Initialize core stores first (no dependencies)
    Alpine.store('galleryMemory', createGalleryMemoryStore());
    Alpine.store('galleryGlobal', createGalleryGlobalStore());
    Alpine.store('galleryUI', createGalleryUIStore());

    Alpine.store('galleryProducts', createGalleryProductsStore());

    // Initialize randomize queue store (depends on memory, products, core stores)
    Alpine.store('galleryRandomizeQueue', createRandomizeQueueStore());

    // Initialize core store (depends on memory and UI stores)
    Alpine.store('galleryCore', createGalleryCoreStore());

    // Initialize feature stores (depend on core store)
    Alpine.store('galleryVariants', createGalleryVariantsStore());
    Alpine.store('galleryLayout', createGalleryLayoutStore());
    Alpine.store('gallerySelection', createGallerySelectionStore());

    Alpine.store('galleryPreview', createGalleryPreviewStore());


  });
}

export function getStoreNames() {
  return [
    'galleryCore',
    'galleryProducts',
    'galleryUI',
    'galleryMemory',
    'galleryVariants',
    'galleryLayout',
    'gallerySelection',
    'galleryGlobal',
    'galleryPreview',
    'galleryRandomizeQueue'
  ];
}

export function debugStores() {
  const stores = {};
  getStoreNames().forEach(name => {
    try {
      stores[name] = Alpine.store(name);
    } catch (error) {
      stores[name] = `Error: ${error.message}`;
    }
  });

  return stores;
}

initializeGalleryStores();